module.exports = __webpack_public_path__ + "img/magnifier.7610ef37.svg";